// extracted by mini-css-extract-plugin
export var margin = "separator-module--margin--wpzXm";
export var separator = "separator-module--separator--KXSn7";